import React from "react";
import { ButtonMob } from "../../../utils/utils";

const ConfirmDeletionModal = ({
  onCancel,
  onConfirm,
  children,
  loader,
  textButton = "Confirmar",
  zIndex = 999,
  customButton = false,
}) => {
  const styleModal = {
    display: "flex",
    position: "fixed",
    zIndex: zIndex,
    whiteSpace: "pre-line",
  };

  return (
    <div
      className="popUpServices justify-content-center align-items-center"
      style={styleModal}
    >
      <div
        className="modalInfoContenido"
        style={{
          background: "white",
          borderRadius: "20px",
          boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
          padding: "6% 10%",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "6%",
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: " #9DACBD",
            cursor: "pointer",
          }}
          onClick={onCancel}
        >
          <i className="bi bi-x-circle"></i>
        </div>

        <div
          className="pt-3 my-4 mx-auto"
          style={{
            lineHeight: "100%",
            textAlign: "center",
            maxWidth: "30rem",
            color: "var(--elevvabutonLogin_User)",
          }}
        >
          {children} {/* Aquí se renderizan los children */}
        </div>

        {customButton ? (
          <ButtonMob
            handleClick={onConfirm}
            colorButton={"transparent"}
            colorTextButton={"var(--elevvabutonLogin_User)"}
            borderbutton="1px solid var(--elevvabutonLogin_User)"
            text={loader ? "Cargando..." : textButton}
            className={"mb-3 mt-3 letraspopfi2actualizar"}
          />
        ) : (
          <ButtonMob
            handleClick={onConfirm}
            colorButton={"var(--elevvabutonLogin_User)"}
            text={loader ? "Cargando..." : textButton}
            className={"mb-3 mt-3 letraspopfi2actualizar"}
          />
        )}
      </div>
    </div>
  );
};

export default ConfirmDeletionModal;
